<template>
    <form action="">
        <app-form-text-input
            label="Nombre"
            v-model="item.name"
            :has-error="$v.item.name.$error"
            error-message="Debe escribir el nombre del item"
            :required="true"
        />
        <app-form-textarea-input
            label="Descripción"
            v-model="item.description"
        />
        <app-form-text-input
            label="Referencia"
            v-model="item.reference"
            :has-error="$v.item.reference.$error"
            error-message="Debe escribir la referencia del item"
            :required="true"
        />
        <app-currency-input
            v-model="item.unit_price"
            label="Precio Unitario"
            :has-error="$v.item.unit_price.$error"
            error-message="Debe ingresar un precio válido"
            required
        />
        <app-form-select-input
            label="Tipo de Unidad"
            v-model="item.unit_type"
            :options="unitTypeOptions"
        />
        <app-form-select-input
            label="Moneda"
            v-model="item.currency"
            :options="currencyOptions"
            :has-error="$v.item.currency.$error"
            error-message="Debe seleccionar una moneda"
            :required="true"
        />
        <app-form-select-input
            label="Categoría"
            v-model="item.category_id"
            :options="categoryOptions"
            :has-error="$v.item.category_id.$error"
            error-message="Debe seleccionar una categoría"
            :required="true"
        />
        <app-form-select-input
            label="Estado"
            v-model="item.status"
            :options="statusOptions"
        />
        <div class="form-group">
            <div class="form-check">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="hasLabor"
                    v-model="hasLabor"
                />
                <label class="form-check-label" for="hasLabor">
                    Incluir valor de mano de obra
                </label>
            </div>
        </div>
        <app-currency-input
            v-if="hasLabor"
            v-model="item.labor"
            label="Costo de Mano de Obra por Unidad"
            :has-error="hasLabor && $v.item && $v.item.labor && $v.item.labor.$error"
            error-message="Debe ingresar un valor válido de mano de obra"
        />
        <div class="form-group">
            <div class="form-check">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="hasAccesories"
                    v-model="hasAccesories"
                />
                <label class="form-check-label" for="hasAccesories">
                    ¿Incluye accesorios?
                </label>
            </div>
        </div>
        <app-currency-input
            v-if="hasAccesories"
            v-model="item.accesories"
            label="Valor de Accesorios"
            :has-error="hasAccesories && $v.item && $v.item.accesories && $v.item.accesories.$error"
            error-message="Debe ingresar un valor válido de accesorios"
        />
        <app-form-text-input
            label="Horas de Instalación"
            v-model="item.installation_hours"
            type="number"
            step="0.01"
            min="0"
            :has-error="$v.item.installation_hours && $v.item.installation_hours.$error"
            error-message="Debe ingresar un valor válido de horas de instalación"
        />
        <div class="form-group">
            <label class="form-label">
                Imagen de Referencia
                <span class="field-optional-mark">(Opcional)</span>
            </label>
            <div class="image-upload-section">
                <div v-if="item.image && !imageFile" class="current-image">
                    <img :src="item.image" alt="Imagen actual" class="image-preview" />
                    <button 
                        type="button" 
                        class="btn btn-sm btn-danger mt-2"
                        @click="removeImage"
                    >
                        <i class="fa fa-trash"></i> Eliminar Imagen
                    </button>
                </div>
                <div v-else-if="imagePreview" class="new-image">
                    <img :src="imagePreview" alt="Vista previa" class="image-preview" />
                    <button 
                        type="button" 
                        class="btn btn-sm btn-secondary mt-2"
                        @click="removeNewImage"
                    >
                        <i class="fa fa-times"></i> Cancelar
                    </button>
                </div>
                <div v-else class="image-upload">
                    <b-form-file
                        v-model="imageFile"
                        accept="image/*"
                        :state="imageFileState"
                        placeholder="Seleccione una imagen..."
                        drop-placeholder="Arrastre la imagen aquí..."
                        @input="onImageSelected"
                    ></b-form-file>
                    <small class="form-text text-muted">
                        Formatos permitidos: JPEG, PNG, JPG, GIF. Tamaño máximo: 2MB
                    </small>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import FormTextInput from '../../../UI/Controls/Forms/FormTextInput.vue';
import FormTextareaInput from '../../../UI/Controls/Forms/FormTextareaInput.vue';
import FormSelectInput from '../../../UI/Controls/Forms/FormSelectInput.vue';
import itemsQuotationRepository from '../../../../repositories/items-quotation.repository';
import { required, numeric } from 'vuelidate/lib/validators';
import CurrencyInput from '../../../UI/Controls/Forms/CurrencyInput.vue';
import { getStatusOptions, getCurrencyOptions, getUnitTypeOptions } from '../../../../utils/quotationOptions';

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormTextareaInput: FormTextareaInput,
        appFormSelectInput: FormSelectInput,
        appCurrencyInput: CurrencyInput
    },
    props: {
        selectedItem: {
            type: Object,
            default: null
        },
        categories: {
            type: Array,
            default: () => []
        },
        onSave: {
            type: Function,
            default: () => false
        },
        id: {
            type: String,
            default: () => `item-quotation-form-${parseInt(Math.random() * 10000000)}`
        }
    },
    data() {
        return {
            item: {
                id: '',
                name: '',
                description: '',
                reference: '',
                unit_price: null,
                labor: null,
                accesories: null,
                installation_hours: null,
                unit_type: '',
                currency: 'COP',
                category_id: '',
                status: Number(true),
                image: null
            },
            hasLabor: false,
            hasAccesories: false,
            currencyOptions: getCurrencyOptions(),
            unitTypeOptions: getUnitTypeOptions(),
            statusOptions: getStatusOptions(),
            imageFile: null,
            imagePreview: null
        };
    },
    computed: {
        categoryOptions() {
            return this.categories.map(cat => ({
                id: cat.id,
                name: this.formatCategoryName(cat.name, cat.slug)
            }));
        },
        imageFileState() {
            if (!this.imageFile || this.imageFile === 'DELETE') return null;
            if (this.imageFile.size > 2 * 1024 * 1024) return false;
            const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            return validTypes.includes(this.imageFile.type) ? null : false;
        }
    },
    watch: {
        selectedItem(val) {
            if (val) {
                let unitPrice = val.unit_price ?? null;
                
                if (unitPrice !== null && unitPrice !== undefined) {
                    unitPrice = typeof unitPrice === 'string' ? parseFloat(unitPrice) : Number(unitPrice);
                    unitPrice = isNaN(unitPrice) ? null : unitPrice;
                }

                let laborPrice = val.labor ?? null;
                if (laborPrice !== null && laborPrice !== undefined) {
                    laborPrice = typeof laborPrice === 'string' ? parseFloat(laborPrice) : Number(laborPrice);
                    laborPrice = isNaN(laborPrice) ? null : laborPrice;
                }

                let accesoriesPrice = val.accesories ?? null;
                if (accesoriesPrice !== null && accesoriesPrice !== undefined) {
                    accesoriesPrice = typeof accesoriesPrice === 'string' ? parseFloat(accesoriesPrice) : Number(accesoriesPrice);
                    accesoriesPrice = isNaN(accesoriesPrice) ? null : accesoriesPrice;
                }

                let installationHours = val.installation_hours ?? null;
                if (installationHours !== null && installationHours !== undefined) {
                    installationHours = typeof installationHours === 'string' ? parseFloat(installationHours) : Number(installationHours);
                    installationHours = isNaN(installationHours) ? null : installationHours;
                }

                this.hasLabor = laborPrice !== null && laborPrice !== undefined && laborPrice > 0;
                this.hasAccesories = accesoriesPrice !== null && accesoriesPrice !== undefined && accesoriesPrice > 0;

                this.item = {
                    id: val.id,
                    name: val.name || '',
                    description: val.description || '',
                    reference: val.reference || '',
                    unit_price: unitPrice,
                    labor: laborPrice,
                    accesories: accesoriesPrice,
                    installation_hours: installationHours,
                    unit_type: val.unit_type || '',
                    currency: val.currency || 'COP',
                    category_id: val.category_id || '',
                    status: Number(val.status) ?? Number(true),
                    image: val.image || null
                };
                this.imageFile = null;
                this.imagePreview = null;
            }
        },
        imageFile: {
            handler(val) {
                if (!val) {
                    this.imagePreview = null;
                }
            }
        },
        hasLabor(val) {
            if (!val) {
                this.item.labor = null;
            } else if (this.item.labor === null || this.item.labor === undefined) {
                this.$set(this.item, 'labor', null);
            }
        },
        hasAccesories(val) {
            if (!val) {
                this.item.accesories = null;
            } else if (this.item.accesories === null || this.item.accesories === undefined) {
                this.$set(this.item, 'accesories', null);
            }
        }
    },
    validations: {
        item: {
            name: { required },
            reference: { required },
            unit_price: { required, numeric },
            currency: { required },
            category_id: { required },
            labor: {
                numeric: function(value) {
                    if (!this.hasLabor) return true;
                    if (value === null || value === undefined || value === '') return false;
                    return !isNaN(parseFloat(value));
                }
            },
            accesories: {
                numeric: function(value) {
                    if (!this.hasAccesories) return true;
                    if (value === null || value === undefined || value === '') return false;
                    return !isNaN(parseFloat(value));
                }
            },
            installation_hours: {
                numeric: function(value) {
                    if (value === null || value === undefined || value === '') return true;
                    return !isNaN(parseFloat(value)) && parseFloat(value) >= 0;
                }
            }
        }
    },
    methods: {
        formatCategoryName(name, slug) {
            const names = {
                slug: name
            };
            return names[slug] || name;
        },
        clear() {
            this.item = {
                id: '',
                name: '',
                description: '',
                reference: '',
                unit_price: null,
                labor: null,
                accesories: null,
                installation_hours: null,
                unit_type: '',
                currency: 'COP',
                category_id: '',
                status: Number(true),
                image: null
            };
            this.hasLabor = false;
            this.hasAccesories = false;
            this.imageFile = null;
            this.imagePreview = null;
            this.$nextTick(() => {
                if (this.$v) {
                    this.$v.$reset();
                }
            });
        },
        onImageSelected(file) {
            if (!file) {
                this.imagePreview = null;
                return;
            }

            if (file.size > 2 * 1024 * 1024) {
                toastr.error('La imagen no debe superar los 2MB');
                this.imageFile = null;
                this.imagePreview = null;
                return;
            }

            const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!validTypes.includes(file.type)) {
                toastr.error('Formato de imagen no válido. Use JPEG, PNG o JPG');
                this.imageFile = null;
                this.imagePreview = null;
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                this.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        removeImage() {
            this.item.image = null;
            if (this.item.id) {
                this.imageFile = 'DELETE';
            }
        },
        removeNewImage() {
            this.imageFile = null;
            this.imagePreview = null;
        },
        async saveItem() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error('Por favor complete todos los campos requeridos');
                return;
            }

            const pr = { ...itemsQuotationRepository };
            
            const payload = { 
                ...this.item,
                unit_price: this.item.unit_price || 0,
                labor: this.hasLabor ? (this.item.labor || null) : null,
                accesories: this.hasAccesories ? (this.item.accesories || null) : null,
                installation_hours: this.item.installation_hours || null,
                status: this.item.status === 1 || this.item.status === true || this.item.status === '1'
            };
            if (this.imageFile === 'DELETE') {
                payload.remove_image = '1';
            }
            
            if (this.imageFile && this.imageFile !== 'DELETE') {
                try {
                    const base64Image = await this.fileToBase64(this.imageFile);
                    payload.image = base64Image;
                } catch (error) {
                    console.error('Error al convertir imagen a base64:', error);
                    toastr.error('Error al procesar la imagen');
                    return;
                }
            }
            
            const promise = this.item.id
                ? pr.updateItem(payload, this.item.id)
                : pr.saveItem(payload);

            promise
                .then(response => {
                    if (response && response.status) {
                        this.clear();
                        toastr.success(response.msg || 'Información guardada satisfactoriamente');
                        this.onSave();
                    } else {
                        toastr.error(response?.msg || 'Error al guardar el item');
                    }
                })
                .catch(error => {
                    console.error('Error al guardar:', error);
                    toastr.error('Ocurrió un error al guardar el item');
                });
        },
        fileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        }
    },
    created() {
        this.$bus.$on('item-quotation-form.save', this.saveItem);
        this.$bus.$on(`${this.id}.clear`, this.clear);
    },
    beforeDestroy() {
        this.$bus.$off('item-quotation-form.save', this.saveItem);
        this.$bus.$off(`${this.id}.clear`, this.clear);
    }
};
</script>
<style scoped lang="scss">
.image-upload-section {
    .current-image,
    .new-image {
        text-align: center;
        
        .image-preview {
            max-width: 100%;
            max-height: 300px;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            margin-bottom: 0.5rem;
        }
    }
    
    .image-upload {
        .form-file {
            margin-bottom: 0.5rem;
        }
    }
}
</style>

